import { ICartItem } from '../../../cart/core/interfaces/ICartItem';

/**
 * Returns tickets that are still available for linking a new external voucher.
 * For each ExternalVoucher in the cart, removes one matching Ticket (multiset).
 */
export function filterTicketsConsumedByExistingExternalVouchers(
  tickets: ICartItem[],
  externalVouchers: ICartItem[]
): ICartItem[] {
  const remaining = [...tickets];

  for (const voucher of externalVouchers) {
    const priceCents = Math.round(Math.abs(voucher.price) * 100);
    const voucherShowId = voucher.showId;

    const index = remaining.findIndex(ticket => {
      const ticketCents = Math.round(ticket.totalPrice * 100);
      if (ticketCents !== priceCents) {
        return false;
      }
      if (voucherShowId > 0) {
        return ticket.showId === voucherShowId;
      }
      return true;
    });

    if (index >= 0) {
      remaining.splice(index, 1);
    }
  }

  return remaining;
}
